import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { resetScore } from '../redux/actions';
import './Ranking.css';

// const decreaseOne = -1;

class Ranking extends Component {
  state = {
    rankings: [],
  };

  componentDidMount() {
    // buscar o array do localStorage
    const ranking = JSON.parse(localStorage.getItem('ranking')) || [];
    this.setState({
      rankings: ranking,
    });
  }

  handleClick = () => {
    const { history, dispatch } = this.props;
    dispatch(resetScore());
    history.push('/');
  };

  render() {
    const { rankings } = this.state;
    return (
      <div className="ranking-container">
        <h1 data-testid="ranking-title">
          Ranking
        </h1>
        {
          rankings.map((ranking, index) => (
            <div
              className="info"
              key={ index }
            >
              <img
                src={ ranking.picture }
                alt={ ranking.name }
              />
              <p
                data-testid={ `player-name-${index}` }
              >
                {ranking.name}
              </p>
              <p
                data-testid={ `player-score-${index}` }
              >
                {ranking.score}
              </p>
            </div>
          ))
        }
        <button
          type="button"
          data-testid="btn-go-home"
          onClick={ this.handleClick }
          className="go-home-btn"
        >
          Inicio
        </button>
      </div>
    );
  }
}

Ranking.propTypes = {
  history: PropTypes.object,
}.isRequired;

export default connect()(Ranking);
